import { render, staticRenderFns } from "./CollectEdit.vue?vue&type=template&id=1f38e52a&scoped=true"
import script from "./CollectEdit.vue?vue&type=script&lang=js"
export * from "./CollectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38e52a",
  null
  
)

export default component.exports